import React, { useEffect } from "react";
import Header from "../../component/mainAdmin/Header";
import Stdassignmentssidebar from "../../component/mainAdmin/stdassignmentssidebar";
import { useLocation, useHistory } from "react-router";
import { getsinglestdassignment } from "../../Redux/action/adminassignment";
import { useSelector, useDispatch } from "react-redux";
import Stdassignmentdetails from "../../component/mainAdmin/stdassignmentdetails";
import {
  emptysinglestdass,
  showsinglestdass,
} from "../../Redux/action/adminassignment/showsinglestdass";
import { getadminallassignments } from "../../Redux/action/adminassignment";

function Assignmentdetails() {
  const { state } = useLocation();
  const history = useHistory();
  console.log(state.id);

  const { adminsingleassignment, adminassignment } = useSelector(
    (state) => state.assignmentreducer
  );

  // const { arrOfStudent, course, batch,assignmentName,totalMarks,_id } = adminsingleassignment;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getadminallassignments());
    return () => {
      dispatch(emptysinglestdass());
    };
  }, []);

  useEffect(() => {
    dispatch(getsinglestdassignment(state.id));
  }, []);

  console.log(adminassignment);

  console.log(adminsingleassignment);

  return (
    <>
      <Header />
      <div
        style={{
          width: "100%",
          height: "7vh",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <h2 style={{ borderBottom: "5px solid green" }}>students work</h2>
      </div>
      <div style={{ display: "flex", overflowY: "hidden" }}>
        <Stdassignmentssidebar
          data={adminsingleassignment?.arrOfStudent}
          totalMarks={adminsingleassignment?.totalMarks}
        />
        <Stdassignmentdetails
          id={adminsingleassignment?._id}
          assignmentName={adminsingleassignment?.assignmentName}
          total={adminsingleassignment?.arrOfStudent?.length}
          totalMarks={adminsingleassignment?.totalMarks}
          students={adminsingleassignment?.arrOfStudent}
        />
      </div>
    </>
  );
}

export default Assignmentdetails;
